// @ts-nocheck
import { Suspense } from 'react'
import dayjs from 'dayjs'
import { colors } from '@lmc/common/constants'
import Field from '../../../fields'

interface StartDateFieldProps {
  fields: Record<string, any>
  formId: string
  readOnly: boolean
  setFormField: (key: string, value: any) => void
  testId?: string
}

/**
 * @description Renders StartDateField for the Add Medication modal
 * @param {StartDateFieldProps} props - The component's props.
 * @returns {JSX.Element} StartDateField.
 */
export default function StartDateField(
  props: StartDateFieldProps
): JSX.Element {
  const { fields, formId, readOnly, setFormField, testId } = props

  const title = 'Start'
  const note = 'The medication will appear in the App from this date'
  const style = {
    ...styles.startDateFieldContainer,
    ...(readOnly ? styles.readOnlyContainer : {})
  }

  return (
    <div
      style={style}
      data-testid={testId ? `${testId}-start-date-field` : 'start-date-field'}
    >
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          displayCalendar
          formId={formId}
          futureDate
          keys="startDate"
          label={title}
          labelChildren={<div style={styles.labelNote}>{note}</div>}
          labelStyle={styles.label}
          layout="column"
          onChange={(value: string) => {
            // Doesn't set weekdays if PRN
            if (!fields.PRN) {
              setFormField({
                key: 'freqDaysInWeek',
                value: value ? [dayjs(value, 'DD-MM-YYYY').format('ddd')] : null
              })
            }
          }}
          required
          type="date"
          values={fields}
        />
      </Suspense>
    </div>
  )
}

const styles = {
  label: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '22px'
  },
  labelNote: {
    color: colors.darkgrey,
    fontSize: 12,
    fontWeight: 400,
    marginBottom: 11
  },
  startDateFieldContainer: {
    background: 'white',
    borderRadius: 15,
    padding: 16,
    marginTop: 16
  },
  readOnlyContainer: {
    opacity: 0.6,
    pointerEvents: 'none'
  }
}
